import { render, staticRenderFns } from "./ReputationModal.vue?vue&type=template&id=2cb67b5e&scoped=true"
import script from "./ReputationModal.vue?vue&type=script&lang=js"
export * from "./ReputationModal.vue?vue&type=script&lang=js"
import style0 from "./ReputationModal.vue?vue&type=style&index=0&id=2cb67b5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb67b5e",
  null
  
)

export default component.exports